export default __webpack_public_path__ + "static/media/ke.83c58c36.svg";